<template>
    <CnaeLists scope="system" />
</template>

<script setup lang="ts">
import CnaeLists from '@/components/CnaeLists.vue';
</script>
